import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";
import videojs from "video.js";
import VideoPlayer from '@/components/VideoPlayer.vue';

const convertNumberService = new ConvertNumService();

export default {
    name: "courseContentList",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
        VideoPlayer,
    },

    data() {
        return {
            lastPage: "",
            currentPage: "",
            contentInfo: {},
            contentGroupInfo: {},
            group_id: this.$route.params.id,
            class_id: this.$route.params.class_id,
            course_id: this.$route.params.courseId,
            server_url_access: process.env.VUE_APP_SERVER,
            url_token: this.$store.state.user['token'],
            videojs,
            accessEndDate:"",
            currentDate:"",
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        downloadFile(content_id, filename) {
            axios.get("my/video-course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + content_id + "/download", {
                headers: {
                    'Content-Type': 'application/pdf',
                },
                responseType: 'blob' // responseType is a sibling of headers, not a child
            })
                .then(response => {
                    this.getContentList();
                    if (response.status == 200) {
                        
                        const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf;base64' }));
                        const tempLink = document.createElement('a');
                        tempLink.style.display = 'none';
                        tempLink.href = fileURL;
                        tempLink.setAttribute('download', filename);
                        setTimeout(function () {
                            var prntWin = window.open();
                            prntWin.document.write("<html><head><title>" + filename + "</title></head><body>"
                                + '<embed width="100%" height="100%" name="plugin" src="' + tempLink + '" '
                                + 'type="application/pdf" internalinstanceid="21"></body></html>');
                            prntWin.document.close();
                        }, 1000);
                    }
                })
                .catch(error => {
                    console.log('hit');

                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.getContentList();
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
        },

        getContentGroup() {
            axios.get("my/video-course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id)
                .then((response) => {
                    this.contentGroupInfo = response.data;
                })
                .catch((error) => {
                    console.log('hit two');
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },
        async showVideoContent(contentId) {
            try {
                this.$router.push({
                    name: "videoStreaming",
                    params: {
                        type: "video-course",
                        course_class_id: this.$route.params.courseId,
                        group_id: this.$route.params.id,
                        id: contentId
                    }
                });
            } catch (error) {
                console.error('Error fetching video:', error);
            }
        },

        async showCourseImageContent(contentId) {
            try {
                this.$router.push({
                    name: "imageStreaming",
                    params: {
                        type: "video-course",
                        course_class_id: this.$route.params.courseId,
                        group_id: this.$route.params.id,
                        id: contentId
                    }
                });
            } catch (error) {
                console.error('Error fetching video:', error);
            }
        },

        close() {
            this.isModalVisible = false;
            this.$emit("close");
        },

        getContentList(page = 1) {
            axios.get("my/video-course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/list?type=course&page=" + page)
                .then((response) => {
                    this.contentInfo = response.data;
                    if (this.contentInfo.data && this.contentInfo.data.length > 0) {
                        this.accessEndDate = this.contentInfo.data[0].end_access_date;
                    } else {
                        this.accessEndDate = null;
                    }
                    this.contentInfo.total = convertNumberService.convertEng2Mm(this.contentInfo.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.contentInfo.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.contentInfo.current_page);
                })
                .catch((error) => {
                    console.log(error);
                    
                    console.log('hit onthreee');
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        /*
        ** Start
        ** request header for streaming
        **
        */
        videojs.Vhs.xhr.beforeRequest = (options) => {
            if (!options.headers) {
                options.headers = {}
            }
            options.headers["Authorization"] = `Bearer ${this.$store.state.user['token']}`;
        }
        /*
        ** End
        */
        this.group_id = this.$route.params.id;
        this.getContentGroup();
        this.getContentList();

        const today = new Date();
        this.currentDate = today.toISOString().split("T")[0];
    },
};
